import {
    FETCH_TREND_PAIRING_DATA_START,
    FETCH_TREND_PAIRING_DATA_SUCCESS,
    FETCH_TREND_PAIRING_DATA_FAIL
} from "../../../constants";
import { ApiBase } from "../../../../utils/apiBase";
import { withType } from "../../../../utils/actionOperations";
import { GET_TREND_DATA } from "../../../../../config/constants";
import { getProjectIdAndOrgId } from '../../../../utils/apiUtils';

export const NewDashboardFetchTrendPairingData = (payload, cb) => {
    const apiBaseInstance = new ApiBase();
    return (dispatch) => {
        dispatch(withType(FETCH_TREND_PAIRING_DATA_START, {}));
        apiBaseInstance.instance
            .post(GET_TREND_DATA, { ...payload.apiPayload, ...getProjectIdAndOrgId(payload) })
            .then((response) => {
                dispatch(
                    withType(FETCH_TREND_PAIRING_DATA_SUCCESS, {
                        data: response.data,
                        projectDetails: { questionSet: payload.questionSet, projectType: payload.projectType },
                        isDataCollection: payload.isDataCollection,
                        message: response.message,
                        isInitialCall: payload.isIntialCall
                    })
                );
                cb && cb(true);
            })
            .catch((err) => {
                dispatch(
                    withType(FETCH_TREND_PAIRING_DATA_FAIL, {
                        error: err,
                    })
                );
                cb && cb(false);
            });
    };
};
